module.exports = __webpack_public_path__ + "static/media/scrapper.ac101121.png";